import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Jika email terdaftar, link reset password telah dikirim.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Gagal memproses");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#f7f9f7] p-4">
      <div className="w-full max-w-md imsyaf-card p-8">
        <div className="text-xs uppercase tracking-widest text-slate-400">IMSYAF</div>
        <h1 className="font-display text-2xl font-bold text-[#064E3B] mt-1">Lupa Password</h1>
        <p className="text-sm text-slate-500 mt-1">
          Masukkan email akun IMSYAF Anda. Kami akan kirim link reset password.
        </p>

        {sent ? (
          <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg text-sm text-green-800" data-testid="forgot-sent-msg">
            📧 Cek inbox email Anda (juga folder spam). Link reset berlaku selama 60 menit.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <div>
              <label className="text-xs">Email</label>
              <input type="email" className="imsyaf-input" value={email}
                onChange={(e) => setEmail(e.target.value)} required
                data-testid="forgot-email-input" />
            </div>
            <button type="submit" disabled={loading}
              className="imsyaf-btn-primary w-full justify-center disabled:opacity-60"
              data-testid="forgot-submit-btn">
              {loading ? "Mengirim..." : "Kirim Link Reset"}
            </button>
          </form>
        )}

        <div className="mt-6 text-center text-sm">
          <Link to="/login" className="text-[#166534] hover:underline" data-testid="forgot-back-login">
            ← Kembali ke login
          </Link>
        </div>
      </div>
    </div>
  );
}
